import { noOp } from 'common/Constants';
import React from 'react';
import { useSearchActions } from 'src/pages/consumer/components/DishFirstHeader/store';
import { Container, ImageContainer, InfoContainer, StaticContainer, SubTitle, TextContainer, Title } from './styles';
import { BaseCardProps } from './types';

export const BaseCard: React.FC<BaseCardProps> = ({ image, title, subtitle, link, onClick = noOp, rating }) => {
  const { hide } = useSearchActions();

  const contents = (
    <>
      <ImageContainer>{image}</ImageContainer>
      <InfoContainer>
        <TextContainer>
          <Title>{title}</Title>
          <SubTitle>{subtitle}</SubTitle>
        </TextContainer>
        {rating ?? null}
      </InfoContainer>
    </>
  );

  return link ? (
    <Container
      to={link}
      onClick={() => {
        hide();
        onClick();
      }}>
      {contents}
    </Container>
  ) : (
    <StaticContainer>{contents}</StaticContainer>
  );
};
